module.exports = __webpack_public_path__ + "static/media/Emily Mattevi.a5ffc7fa.png";